module.exports = __webpack_public_path__ + "static/media/export.6ee8faf0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/export.svg
// module id = 1981
// module chunks = 0